<template>
  <div>
    <el-row>
      <el-card style="margin: auto;">
        <div slot="header" class="clearfix">
          <span style="float:left; font-weight: 800">使用中的角色</span>
          <el-button style="float: right" size="small" type="text" @click="show_add">添加新角色</el-button>
        </div>

        <!-- 创建角色 -->
        <el-dialog :visible.sync="visible" title="新建角色" width="30%">
          <el-form ref="role" :model="role" label-width="80px">
            <el-form-item prop="name" label="名称" required>
              <el-input v-model="role.name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item prop="users" label="用户" required>
              <el-select v-model="role.users" filterable multiple style="display:block;">
                <el-option v-for="i in users" :key="i.id" :value="i.name" :label="i.name"></el-option>
              </el-select>
            </el-form-item>
            <div v-for="(r, index) in role.rules" :key="index">
              <el-card style="margin:5px">
                <span style="float:left;font-weight:800;margin-bottom:10px">角色规则</span>
                <div class="clearfix"></div>
                <el-form-item label="资源" required>
                  <el-select
                    v-model="r.resource"
                    multiple
                    filterable
                    placeholder="请选择资源类型"
                    style="display:block;"
                  >
                    <el-option v-for="i in resources" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="权限" required>
                  <el-select
                    v-model="r.action"
                    multiple
                    filterable
                    placeholder="请选择权限"
                    style="display:block;"
                  >
                    <el-option v-for="i in actions" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
            </div>
          </el-form>
          <template slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="success" @click="add_rule">新增规则</el-button>
            <el-button size="small" type="primary" @click="create_role">创建</el-button>
          </template>
        </el-dialog>

        <!-- 角色表格 -->
        <el-table :data="roles" stripe>
          <el-table-column label="名称" prop>
            <template slot-scope="scope">
              <span>{{scope.row}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="info" size="mini" @click="get_role(scope.row)">详情</el-button>
              <el-button type="primary" size="mini" @click="handle_add_permission(scope.row)">添加权限</el-button>
              <el-button type="danger" size="mini" @click="delete_role(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="page_size"
            @current-change="get_roles"
          ></el-pagination>
        </div>

        <!-- 编辑角色 删除权限 -->
        <el-dialog :visible.sync="edit_visible" :title="this.edit_role_name + '权限列表'" width="30%">
          <el-table :data="role_rules" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column label="Resource" prop="resource"></el-table-column>
            <el-table-column label="Action" prop="action"></el-table-column>
          </el-table>
          <template slot="footer">
            <el-button size="small" @click="edit_visible = false">取消</el-button>
            <el-button size="small" @click="update_role('del')" type="primary">删除权限</el-button>
          </template>
        </el-dialog>

        <!-- 编辑角色 添加权限 -->
        <el-dialog
          :visible.sync="add_permission_visible"
          :title="this.edit_role_name + '添加权限'"
          width="30%"
        >
          <el-form label-width="80px">
            <div v-for="(r, index) in add_role_rules" :key="index">
              <el-card style="margin:5px">
                <span style="float:left;font-weight:800;margin-bottom:10px">角色规则</span>
                <div class="clearfix"></div>
                <el-form-item label="资源" required>
                  <el-select
                    v-model="r.resource"
                    multiple
                    filterable
                    placeholder="请选择资源类型"
                    style="display:block;"
                  >
                    <el-option v-for="i in resources" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="权限" required>
                  <el-select
                    v-model="r.action"
                    multiple
                    filterable
                    placeholder="请选择权限"
                    style="display:block;"
                  >
                    <el-option v-for="i in actions" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
            </div>
          </el-form>
          <template slot="footer">
            <el-button size="small" @click="add_permission_visible = false">取消</el-button>
            <el-button size="small" type="success" @click="add_rule_on_edit">新增规则</el-button>
            <el-button size="small" type="primary" @click="update_role('add')">添加</el-button>
          </template>
        </el-dialog>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      page_size: 0,
      total: 0,
      edit_visible: false,
      add_permission_visible: false,
      roles: [],
      edit_role_name: "",
      resources: [],
      edit_role: [],
      users: [],
      actions: [],
      role: {
        name: "",
        rules: [
          {
            resource: [],
            action: [],
          },
        ],
        users: [],
      },
      role_rules: [
        {
          resource: "",
          action: "",
        },
      ],
      add_role_rules: [
        {
          resource: [],
          action: [],
        },
      ],
      multipleSelection: [],
    };
  },
  created() {
    this.page_size = this.config.pageSize;
    this.resources = this.config.resources;
    this.actions = this.config.actions;
    this.get_roles(1);
    this.get_users();
  },
  methods: {
    get_roles(page) {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/roles?currentPage=" +
            page +
            "&pageSize=" +
            this.page_size,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取角色列表失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            _this.total = res.data.page.totalCount;
            _this.roles = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取角色列表失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
          console.log("get roles list error: ", err.toString());
        });
    },
    get_users() {
      var _this = this;
      _this.$axios
        .get(_this.config.path + "/users?currentPage=0&pageSize=15", {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取用户数据失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.users = response.data.data;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户数据失败: " + error.toString(),
            type: "error",
          });
        });
    },
    show_add() {
      this.role = {
        name: "",
        rules: [
          {
            resource: [],
            action: [],
          },
        ],
        users: [],
      };
      this.visible = true;
    },
    add_rule() {
      this.role.rules.push({
        resource: [],
        action: [],
      });
    },
    add_rule_on_edit() {
      this.add_role_rules.push({
        resource: [],
        action: [],
      });
    },
    create_role() {
      const _this = this;
      console.log("create a new role:", _this.role);
      _this.$refs["role"].validate((valid) => {
        if (valid) {
          console.log("new role: ", _this.role);
          _this.$axios
            .post(_this.config.path + "/roles", _this.role, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  message: "创建角色失败: " + res.data.message,
                  showClose: true,
                  type: "error",
                });
              } else {
                _this.$message({
                  message: "创建角色成功",
                  showClose: true,
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (err) {
              _this.$message({
                message: "创建角色失败: " + err.toString(),
                showClose: true,
                type: "error",
              });
            });
        } else {
          _this.$message({
            message: "创建角色失败请填写必要的信息",
            showClose: true,
            type: "error",
          });
          return false;
        }
      });
      this.visible = false;
    },
    get_role(name) {
      console.log("get role info by name:", name);
      this.edit_role_name = name;
      this.role_rules = [];
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/roles/" + name, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取角色信息失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              let r = {
                resource: res.data.data[i][1],
                action: res.data.data[i][2],
              };
              _this.role_rules.push(r);
            }
          }
        })
        .catch(function (err) {
          _this.$message["error"]({
            message: "获取角色信息失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
      _this.edit_visible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handle_add_permission(name) {
      this.add_role_rules = [
        {
          resource: [],
          action: [],
        },
      ],
      this.edit_role_name = name
      this.add_permission_visible = true
    },
    update_role(action) {
      console.log("update role name: ", this.edit_role_name);
      let rules = []
      if (action === 'add') {
        for (var i=0; i<this.add_role_rules.length;i++) {
          for (var j=0; j<this.add_role_rules[i].resource.length;j++) {
            for (var n=0; n<this.add_role_rules[i].action.length;n++) {
              let r = {
                'resource': this.add_role_rules[i].resource[j], 
                'action': this.add_role_rules[i].action[n]
              }
              rules.push(r)
            }
          }
        }
      }
      let role = {
        name: this.edit_role_name,
        rules: this.multipleSelection,
      };
      if (action === 'add') {
        role.rules = rules
      }
      const _this = this;
      _this.$axios
        .put(
          _this.config.path +
            "/roles/" +
            _this.edit_role_name +
            "?edit=" +
            action,
          role,
          {
            headers: {
              Authorization: "Bearer " + this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === true) {
            _this.$message({
              message: "更新成功",
              type: "success",
              showClose: true,
            });
            setTimeout(function () {
              _this.$router.go(0);
            }, 500);
          } else {
            _this.$message({
              message: "更新失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "更新失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
      _this.edit_visible = false;
    },
    delete_role(name) {
      console.log("delete role name: ", name);
      const _this = this;
      this.$confirm("删除角色后无法还原，确认删除么？", "删除角色", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          _this.$axios
            .delete(_this.config.path + "/roles/" + name, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  message: "删除角色失败: " + res.data.message,
                  showClose: true,
                  type: "error",
                });
              } else {
                _this.$message({
                  message: "删除角色成功",
                  showClose: true,
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (err) {
              _this.$message({
                message: "删除角色失败: " + err.toString(),
                showClose: true,
                type: "error",
              });
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>